<script>
import ModalAuth from "./ModalAuth.vue";
import ModalSales from "./ModalSales.vue";

export default {
  name: "Modals",
  components:{
    ModalAuth,
    ModalSales
  },
  data(){
    return {
      openModalName:''
    }
  },
  methods:{
    openModal(modalName){

      this.openModalName = modalName;
      this.$nextTick(()=>{
        $(".modal-wrapper").addClass("active")
        this.openModalName = modalName;
      })
    },
    closeModal(){
      $(".modal-wrapper").removeClass("active")
      this.openModalName = '';
    }
  }
}
</script>

<template>
  <div class="modal-wrapper">
    <Transition name="fade-modal" mode="out-in">
      <modal-auth ref="modalAuth" v-if="openModalName === 'modalAuth'"></modal-auth>
      <modal-sales ref="modalSales" v-if="openModalName === 'modalSales'"></modal-sales>
    </Transition>
    <div class="modal-bg" @click="closeModal"></div>
  </div>
</template>

<style scoped>

</style>